import { TDynamicStoreField } from '../../../store/store';
import { Limit, MarketingConsent } from '../../../types/types';
import { COOKIE_NAMES } from '../../../utils/constants';
import { getCookieByName } from '../../../utils/cookies';
import { currentCountryMarketInfo } from '../../../utils/countries';
import { gatekeeper } from '../../../utils/gatekeeper';
import { getDepositLimitData, separateBirthdate } from '../../../utils/utils';

export class UKGC {
  email: string;
  firstName: string;
  lastName: string;
  plainTextPassword: string;
  phonePrefix: string;
  phoneNumber: string;
  phoneVerified: boolean;
  dayOfBirth: number;
  monthOfBirth: number;
  yearOfBirth: number;
  gender: string;
  address: {
    country: string;
    city: string;
    postalCode: string;
    streetName: string;
    isVerified: boolean;
    houseNumber: string;
  };
  placeOfBirth: {
    city: string;
    country: string;
  };
  nationality: string;
  welcomeOfferId?: string;
  trackingId: string;
  marketCode: string;
  subscribeToMarketingMaterial: boolean;
  marketingConsent: MarketingConsent;
  limit: Limit | null;

  constructor(data: TDynamicStoreField | null) {
    if (!data) throw new Error('Data is required to instantiate UKGC.');
    const { dayOfBirth, monthOfBirth, yearOfBirth } =
    separateBirthdate(data.dateOfBirth) || {};
    const countryInfo = currentCountryMarketInfo(gatekeeper?.localisation?.marketSlug);

    if (!dayOfBirth || !monthOfBirth || !yearOfBirth) {
      throw new Error('Day, month, and year of birth are mandatory.');
    }

    this.email = data.email?.trim();
    this.firstName = data.firstName?.trim();
    this.lastName = data.lastName?.trim();
    this.plainTextPassword = data.plainTextPassword?.trim();
    this.phonePrefix = data.phonePrefix;
    this.phoneNumber = data.phoneNumber?.trim();
    this.phoneVerified = false;
    this.dayOfBirth = dayOfBirth;
    this.monthOfBirth = monthOfBirth;
    this.yearOfBirth = yearOfBirth;
    this.gender = data.gender?.toUpperCase();
    this.nationality = data.nationality?.trim();
    this.welcomeOfferId = data.welcomeOffer;
    this.trackingId = getCookieByName(COOKIE_NAMES.KAZUMO_TRACKING_ID) ?? '';
    this.marketCode = countryInfo?.marketCode ?? '';
    //TODO implement considering marketing consent
    this.subscribeToMarketingMaterial = data.subscribeToMarketingMaterial ?? false;
    this.marketingConsent = data.marketingConsent ?? false;
    this.limit = getDepositLimitData(data.daily, data.weekly, data.monthly, countryInfo?.currency ?? 'GBP');

    if (
      !data.countryOfResidence ||
      !data.city ||
      !data.postcode ||
      !data.street ||
      !data.houseNumber
    ) {
      throw new Error('All address fields are mandatory.');
    }

    this.address = {
      country:     data.countryOfResidence.trim(),
      city:        data.city.trim(),
      streetName:  data.street.trim(),
      houseNumber: data.houseNumber.trim(),
      postalCode:  data.postcode.trim(),
      isVerified:  true,
    };

    if (!data.cityOfBirth || !data.countryOfBirth) {
      throw new Error('Place of birth fields are mandatory.');
    }

    this.placeOfBirth = {
      city:    data.cityOfBirth.trim(),
      country: data.countryOfBirth,
    };
  }

  get data() {
    return { ...this };
  }
}
